<template>
  <div
    class="quark-element-group-wrapper"
    :id="element.uuid"
    @click="handleClick"
  >
    <componentsTemplate
      v-for="(item, index) in element.list"
      :key="index"
      :loaded="item._loaded"
      :element="item"
      :elementsAll="elementsAll"
      :elementGroups="elementGroups"
      :scalingRatio="scalingRatio"
      :style="getCommonStyle(getMemberStyle(item), scalingRatioDefault)"
      @router="changeRouter"
    >
    </componentsTemplate>
  </div>
</template>

<script>
import { getCommonStyle } from "@/assets/js/utils";
import componentsTemplate from "./components-template";
import runAnimations from "@/assets/js/runAnimations";
import elementEvents from "@/assets/js/elementEvents";

export default {
  name: "components-group-template",
  components: {
    componentsTemplate,
  },
  data() {
    return {
      getCommonStyle: getCommonStyle,
      scalingRatioDefault: 1,
    };
  },
  props: {
    // 元素数据
    element: {
      type: Object,
      require: true,
    },
    elementsAll: Array,
    elementGroups: Array,
    scalingRatio: Number,
  },
  mixins: [elementEvents],
  mounted() {
    this.cssAnimations();
  },
  methods: {
    changeRouter(e) {
      this.$emit("router", e);
    },
    getMemberStyle(item) {
      const percent = this.element.relativeData.find(
        (i) => i.uuid == item.uuid
      );
      const defaultStyle = this.element.defaultStyle;
      const style = item.commonStyle;
      style.width = percent.width * defaultStyle.width;
      style.height = percent.height * defaultStyle.height;
      style.top = percent.top * defaultStyle.height;
      style.left = percent.left * defaultStyle.width;
      return style;
    },
    async handleClick() {
      for (let i = 0, len = this.element.events.length; i < len; i++) {
        if (this["_event_" + this.element.events[i].type]) {
          await this["_event_" + this.element.events[i].type](
            this.element.events[i],
            this
          );
        }
      }
    },
    cssAnimations() {
      // let cssText = this.$el.style.cssText;
      let animations = this.element.animations || [];
      animations = animations.filter(
        (z) => z.type.toLowerCase().indexOf("in") > -1
      );
      runAnimations(this.$el, animations, false, () => {
        // this.$el.style.cssText = cssText
      });
    },
  },
};
</script>
